import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import ReceptionMobile from './Reception.mobile';
import ReceptionWeb from './Reception.web';

const ReceptionScreen = () => {
  const navigate = useAppNavigate();
  const { isMobile } = useResponsive();
  return isMobile ? <ReceptionMobile navigate={navigate} /> : <ReceptionWeb navigate={navigate} />;
};

export default ReceptionScreen;
